import { GlobalSubheader } from "../models/global-subheader.model";
import * as GlobalSubheaderActions from "../actions/global-subheader.actions";

const initialState: GlobalSubheader = {
  pageName: "",
  subheaderTitle: "",
  superScript: "",
  link: "",
  ticker: "",
  subheaderChanged: false,
  brokerList: [],
  entitlementList: [],
  dpParams: {},
  isAuditCall: { expanded: false },
  disableActions: false,
  revisionExportDate: "",
};

export function globalSubheaderReducer(
  state: GlobalSubheader = initialState,
  action: GlobalSubheaderActions.Actions,
) {
  switch (action.type) {
    case GlobalSubheaderActions.PAGE_NAME_CHANGED:
      return {
        ...state,
        pageName: action.payload,
      };
    case GlobalSubheaderActions.SET_REVISION_DATE_FOR_EXPORT:
      return {
        ...state,
        revisionExportDate: action.payload,
      };
    case GlobalSubheaderActions.TICKER_CHANGED:
      return {
        ...state,
        ticker: action.payload,
      };
    case GlobalSubheaderActions.SUBHEADER_CHANGED:
      return {
        ...state,
        subheaderChanged: !state.subheaderChanged,
      };
    case GlobalSubheaderActions.SUBHEADER_TITLE_CHANGED:
      return {
        ...state,
        subheaderTitle: decodeURIComponent(action.payload.title),
        superScript: action.payload.sup,
        link: action.payload.link,
      };
    case GlobalSubheaderActions.SET_BROKER_LIST:
      return {
        ...state,
        brokerList: action.payload,
      };
    case GlobalSubheaderActions.SET_ENTITLEMENT_LIST:
      return {
        ...state,
        entitlementList: action.payload,
      };
    case GlobalSubheaderActions.SET_DP_PARAMS:
      return {
        ...state,
        dpParams: action.payload,
      };
    case GlobalSubheaderActions.SET_AUDIT_CALL_FBAR:
      return {
        ...state,
        isAuditCall: action.payload,
      };
    case GlobalSubheaderActions.DELETE_DP_PARAMS:
      return {
        ...state,
        dpParams: {},
      };
    case GlobalSubheaderActions.SET_DISABLE_ACTIONS:
      return {
        ...state,
        disableActions: action.payload,
      };
    default:
      return state;
  }
}
